export enum EBreakpoint {
  XSmall = 600,
  XSM = 750,
  Small = 960,
  Medium = 1264,
  Large = 1920,
}
